/* src/app/components/elibraryandcourse/e-library/e-library-details/e-library-tile/e-library-tile.component.scss */
:host {
  display: block;
  width: 100%;
}
.document-library {
  min-height: 100%;
  padding: 2px;
  color: #172033;
}
.library-header {
  margin-bottom: 24px;
}
.header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 20px;
}
.header-title {
  display: flex;
  align-items: center;
  gap: 14px;
}
.header-title h2 {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  letter-spacing: -0.4px;
  color: #182033;
}
.header-title p {
  margin: 4px 0 0;
  color: #7a8499;
  font-size: 13px;
}
.title-icon {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #253B80;
  color: #fff;
  font-size: 20px;
  box-shadow: 0 8px 20px rgba(86, 104, 242, 0.22);
}
.library-stats {
  display: grid;
  grid-template-columns: repeat(3, minmax(180px, 1fr));
  gap: 16px;
}
.select-all-card {
  min-height: 78px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.select-all-card:hover {
  border-color: #253B80;
  background: #fafbff;
  box-shadow: 0 8px 20px rgba(86, 104, 242, 0.08);
}
.select-all {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
}
.select-all input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}
.custom-check {
  width: 22px;
  height: 22px;
  flex: 0 0 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1.5px solid #d5dae5;
  border-radius: 7px;
  background: #fff;
  color: transparent;
  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    transform 0.2s ease;
}
.custom-check i {
  font-size: 11px;
  font-weight: 700;
}
.select-all input:checked + .custom-check {
  background: #253B80;
  border-color: #253B80;
  color: #fff;
  transform: scale(1.05);
}
.select-all-text {
  color: #3f485b;
  font-size: 13px;
  font-weight: 600;
}
.stat-card {
  background: #fff;
  border: 1px solid #e8ebf2;
  border-radius: 16px;
  padding: 18px;
  display: flex;
  align-items: center;
  gap: 14px;
  box-shadow: 0 5px 18px rgba(25, 35, 55, 0.035);
}
.stat-icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 17px;
}
.stat-icon.documents {
  background: #eef2ff;
  color: #253B80;
}
.stat-icon.users {
  background: #eafaf4;
  color: #16a47a;
}
.stat-icon.storage {
  background: #fff4e8;
  color: #ed8b2d;
}
.stat-value {
  display: block;
  font-size: 20px;
  font-weight: 700;
  line-height: 1.2;
}
.stat-label {
  display: block;
  margin-top: 4px;
  color: #8a93a5;
  font-size: 12px;
}
.document-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
  gap: 16px;
  align-items: start;
  grid-auto-rows: min-content;
}
.document-grid-item {
  min-width: 0;
}
.document-grid-item {
  position: relative;
  z-index: 1;
}
.document-grid-item.menu-open {
  z-index: 999;
}
.document-grid-item.menu-open .document-card {
  transform: none !important;
}
.document-card {
  position: relative;
  overflow: visible;
  min-height: unset;
  background: #fff;
  border: 1px solid #e6e9f0;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  transition:
    transform 0.25s ease,
    box-shadow 0.25s ease,
    border-color 0.25s ease;
}
.document-card:hover {
  transform: translateY(-4px);
  border-color: #dce1f8;
  box-shadow: 0 16px 35px rgba(28, 39, 65, 0.09);
}
.document-card:hover .preview-overlay {
  opacity: 1;
}
.document-card:hover .document-thumbnail {
  transform: scale(1.04);
}
.drag-button {
  position: absolute;
  z-index: 10;
  right: 8px;
  top: 8px;
  width: 24px;
  height: 24px;
  border: 0;
  border-radius: 9px;
  background: rgba(255, 255, 255, 0.92);
  color: #70798d;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: grab;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}
.drag-button:active {
  cursor: grabbing;
}
.document-check {
  top: 8px;
  right: 8px;
}
.document-check label {
  width: 18px;
  height: 18px;
}
.document-check {
  position: absolute;
  z-index: 10;
}
.document-check input {
  display: none;
}
.document-check label {
  width: 22px;
  height: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  border: 1.5px solid #d6dbe5;
  background: rgba(255, 255, 255, 0.95);
  cursor: pointer;
  color: transparent;
  font-size: 10px;
}
.document-check input:checked + label {
  background: #253B80;
  border-color: #253B80;
  color: #fff;
}
.document-preview {
  aspect-ratio: 16/10;
  height: auto;
  position: relative;
  overflow: hidden;
  border-radius: 12px 12px 0 0;
  background:
    linear-gradient(
      135deg,
      #f0f3fa,
      #e8ecf6);
  cursor: pointer;
}
.document-thumbnail {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.35s ease;
}
.file-icon-wrapper {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.file-type-icon {
  width: 52px;
  height: 52px;
  object-fit: contain;
  filter: drop-shadow(0 8px 12px rgba(40, 50, 80, 0.1));
}
.preview-overlay {
  inset: auto 10px 10px auto;
  width: auto;
  height: auto;
  background: transparent;
  opacity: 1;
}
.preview-button {
  width: 34px;
  height: 34px;
  background: rgba(255, 255, 255, 0.92);
}
.video-duration,
.file-extension {
  position: absolute;
  bottom: 6px;
  padding: 3px 6px;
  border-radius: 7px;
  background: rgba(20, 27, 44, 0.78);
  color: #fff;
  font-size: 9px;
  font-weight: 600;
}
.video-duration {
  left: 10px;
}
.video-duration i {
  margin-right: 3px;
}
.file-extension {
  right: 10px;
  text-transform: uppercase;
}
.document-body {
  flex: 1;
  padding: 10px 12px 8px;
}
.document-main {
  min-width: 0;
}
.document-title {
  margin: 0;
  color: #20283a;
  font-size: 12.5px;
  font-weight: 650;
  line-height: 1.35;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.document-meta {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 9px;
  color: #929aaa;
  font-size: 10px;
}
.document-meta span {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  min-width: 0;
}
.document-meta i {
  font-size: 10px;
}
.document-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 3px;
  margin-top: 8px;
}
.icon-action {
  position: relative;
  width: 27px;
  height: 27px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 1px solid transparent;
  border-radius: 8px;
  background: #f6f7fa;
  color: #737c90;
  cursor: pointer;
  transition:
    background-color 0.2s ease,
    color 0.2s ease,
    border-color 0.2s ease,
    transform 0.2s ease,
    box-shadow 0.2s ease;
}
.icon-action i {
  font-size: 10px;
  line-height: 1;
  transition: transform 0.2s ease;
}
.icon-action:hover {
  background: #eef0ff;
  border-color: #e1e5ff;
  color: #253B80;
}
.icon-action:hover i {
  transform: scale(1.08);
}
.icon-action:active {
  transform: scale(0.94);
}
.icon-action:focus-visible {
  outline: 2px solid rgba(86, 104, 242, 0.25);
  outline-offset: 2px;
}
.icon-action {
}
.icon-action.publish {
  color: #737c90;
}
.icon-action.publish:hover {
  background: #eafaf4;
  border-color: #d6f4e8;
  color: #16a47a;
}
.icon-action {
}
.icon-action.publish.published {
  background: #eafaf4;
  color: #16a47a;
}
.icon-action.publish.published:hover {
  background: #dcf7eb;
  border-color: #c7efdf;
  color: #12845f;
}
.icon-action {
}
.icon-action.active {
  background: #eef0ff;
  border-color: #dfe3ff;
  color: #253B80;
}
.document-menu {
  position: relative;
  display: inline-flex;
  flex-shrink: 0;
}
.modern-dropdown {
  position: absolute;
  z-index: 99999;
  top: calc(100% + 7px);
  left: 0;
  width: 235px;
  padding: 6px;
  box-sizing: border-box;
  background: #fff;
  border: 1px solid #e8ebf1;
  border-radius: 12px;
  box-shadow: 0 18px 40px rgba(30, 40, 65, 0.13), 0 3px 8px rgba(30, 40, 65, 0.04);
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transform: translate3d(0, -5px, 0);
  transform-origin: top right;
  transition:
    opacity 0.15s ease,
    transform 0.15s ease,
    visibility 0.15s ease;
}
.modern-dropdown.show {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
  transform: translate3d(0, 0, 0);
}
.modern-dropdown.opens-up {
  top: auto;
  bottom: calc(100% + 7px);
}
.modern-dropdown.opens-left {
  left: auto;
  right: 0;
}
button {
  position: relative;
  width: 100%;
  min-height: 38px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #515a6e;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.2;
  text-align: left;
  cursor: pointer;
  transition:
    background-color 0.18s ease,
    color 0.18s ease,
    transform 0.18s ease;
}
button:hover {
  background: #f5f6fb;
  color: #253B80;
}
button:active {
  background: #eef0f8;
}
button:focus-visible {
  outline: 2px solid rgba(86, 104, 242, 0.2);
  outline-offset: -2px;
}
button i {
  flex: 0 0 16px;
  width: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  transition: color 0.18s ease, transform 0.18s ease;
}
button {
}
button.danger {
  margin-top: 4px;
  color: #e24d5b;
}
button.danger:hover {
  background: #fff1f2;
  color: #d63d4c;
}
button.danger {
  border-top: 1px solid #f0f1f4;
  border-radius: 0 0 8px 8px;
  padding-top: 10px;
}
.icon-action[title]::after {
  content: attr(title);
  position: absolute;
  left: 50%;
  bottom: calc(100% + 7px);
  z-index: 100000;
  padding: 5px 8px;
  border-radius: 6px;
  background: #1f2937;
  color: #fff;
  font-size: 10px;
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transform: translate(-50%, 3px);
  transition: opacity 0.15s ease, transform 0.15s ease;
}
.icon-action[title]:hover::after {
  opacity: 1;
  visibility: visible;
  transform: translate(-50%, 0);
}
@media (max-width: 576px) {
  .document-actions {
    gap: 3px;
    margin-top: 10px;
  }
  .icon-action {
    width: 29px;
    height: 29px;
  }
  .icon-action i {
    font-size: 12px;
  }
  .modern-dropdown {
    width: 215px;
  }
}
.document-footer {
  border-top: 1px solid #f0f1f5;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #9aa2b2;
  font-size: 10px;
}
.document-footer span {
  display: inline-flex;
  align-items: center;
  gap: 5px;
}
.published-badge {
  padding: 4px 7px;
  border-radius: 6px;
  background: #eafaf4;
  color: #14976f;
  font-weight: 600;
}
.document-viewer-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 350px;
  gap: 20px;
  align-items: start;
}
.viewer-card,
.viewer-sidebar {
  background: #fff;
  border: 1px solid #e6e9f0;
  border-radius: 18px;
  box-shadow: 0 7px 25px rgba(30, 40, 65, 0.045);
}
.viewer-main {
  min-width: 0;
}
.viewer-header {
  height: 62px;
  padding: 0 18px;
  border-bottom: 1px solid #edf0f4;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.back-button,
.viewer-icon {
  border: 0;
  background: transparent;
  cursor: pointer;
}
.back-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #253B80;
  font-size: 13px;
  font-weight: 600;
}
.viewer-actions {
  display: flex;
  gap: 7px;
}
.viewer-icon {
  width: 34px;
  height: 34px;
  border-radius: 9px;
  background: #f5f6fa;
  color: #687287;
}
.viewer-content {
  min-height: 560px;
  padding: 16px;
  background: #f0f2f6;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.media-container {
  width: 100%;
  overflow: hidden;
  border-radius: 12px;
  background: #101522;
  height: 72vh;
}
.viewer-image {
  max-width: 100%;
  max-height: 600px;
  object-fit: contain;
  border-radius: 10px;
}
.document-frame {
  width: 100%;
  height: 600px;
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
}
.document-frame ngx-doc-viewer {
  display: block;
  width: 100%;
  height: 100%;
}
.watermark {
  position: absolute;
  z-index: 20;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-25deg);
  font-size: 35px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.12);
  pointer-events: none;
  white-space: nowrap;
}
.audio-player {
  min-height: 330px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  background:
    radial-gradient(
      circle at center,
      #2c3550,
      #111624);
}
.audio-artwork {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.audio-artwork i {
  width: 110px;
  height: 110px;
  border-radius: 30px;
  background: rgba(255, 255, 255, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 42px;
  color: #fff;
}
.viewer-details {
  padding: 18px 20px;
  display: flex;
  justify-content: space-between;
  gap: 20px;
}
.viewer-details h2 {
  margin: 0 0 7px;
  font-size: 17px;
  font-weight: 650;
  color: #20283a;
}
.viewer-details p,
.viewer-date {
  margin: 0;
  color: #8c95a6;
  font-size: 11px;
}
.viewer-details p i,
.viewer-date i {
  margin-right: 4px;
}
.viewer-navigation {
  display: flex;
  justify-content: space-between;
  padding: 0 20px 18px;
}
.viewer-navigation button {
  border: 1px solid #e1e5ed;
  background: #fff;
  border-radius: 9px;
  padding: 8px 13px;
  color: #606a7e;
  font-size: 12px;
  cursor: pointer;
}
.viewer-navigation button:hover:not(:disabled) {
  border-color: #253B80;
  color: #253B80;
}
.viewer-navigation button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.description {
  border-top: 1px solid #edf0f4;
  padding: 18px 20px;
  color: #697286;
  font-size: 13px;
  line-height: 1.7;
}
.description h3 {
  margin: 0 0 10px;
  font-size: 14px;
  color: #252e40;
}
.viewer-sidebar {
  position: sticky;
  top: 20px;
  overflow: hidden;
}
.sidebar-tabs {
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-bottom: 1px solid #edf0f4;
}
.sidebar-tabs button {
  border: 0;
  background: transparent;
  padding: 15px 10px;
  color: #8a93a4;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  position: relative;
}
.sidebar-tabs button i {
  margin-right: 5px;
}
.sidebar-tabs button.active {
  color: #253B80;
}
.sidebar-tabs button.active::after {
  content: "";
  position: absolute;
  height: 2px;
  left: 20px;
  right: 20px;
  bottom: 0;
  background: #253B80;
  border-radius: 3px;
}
.sidebar-content {
  max-height: 650px;
  overflow-y: auto;
  padding: 8px;
}
.playlist-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 11px;
  border-radius: 11px;
  cursor: pointer;
  transition: 0.2s ease;
}
.playlist-item:hover {
  background: #f6f7fb;
}
.playlist-item.active {
  background: #eef1ff;
}
.playlist-item.active .playlist-icon {
  background: #253B80;
  color: #fff;
}
.playlist-item.active .playlist-info h4 {
  color: #253B80;
}
.playlist-icon {
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  border-radius: 9px;
  background: #f0f2f7;
  color: #7d8799;
  display: flex;
  align-items: center;
  justify-content: center;
}
.playlist-info {
  flex: 1;
  min-width: 0;
}
.playlist-info h4 {
  margin: 0;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #3e475a;
}
.playlist-info span {
  display: block;
  margin-top: 4px;
  color: #9ba3b1;
  font-size: 10px;
}
.selected-icon {
  color: #253B80;
  font-size: 13px;
}
.notes-panel {
  padding: 14px;
  max-height: 650px;
  overflow-y: auto;
}
.note-item {
  margin-bottom: 14px;
}
.note-item h4 {
  margin: 0 0 8px;
  font-size: 12px;
  line-height: 1.5;
  color: #40495b;
}
.note-item textarea {
  width: 100%;
  min-height: 100px;
  resize: vertical;
  border: 1px solid #e0e4ec;
  border-radius: 10px;
  padding: 10px;
  outline: none;
  font-size: 12px;
  color: #4a5366;
  transition: 0.2s ease;
}
.note-item textarea:focus {
  border-color: #253B80;
  box-shadow: 0 0 0 3px rgba(86, 104, 242, 0.08);
}
.empty-note {
  margin-bottom: 15px;
}
.notes-actions {
  display: flex;
  justify-content: space-between;
  gap: 8px;
  padding-top: 10px;
}
.primary-btn,
.secondary-btn {
  border-radius: 9px;
  padding: 9px 13px;
  border: 0;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.primary-btn {
  background: #253B80;
  color: #fff;
}
.primary-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}
.secondary-btn {
  background: #f1f3f7;
  color: #697387;
}
.cdk-drag-preview {
  box-sizing: border-box;
  border-radius: 18px;
  box-shadow: 0 20px 45px rgba(20, 30, 50, 0.2);
}
.cdk-drag-placeholder {
  opacity: 0.25;
}
.cdk-drop-list-dragging .document-card:not(.cdk-drag-placeholder) {
  transition: transform 200ms ease;
}
.sidebar-content,
.notes-panel {
  scrollbar-width: thin;
  scrollbar-color: #d7dce6 transparent;
}
.sidebar-content::-webkit-scrollbar,
.notes-panel::-webkit-scrollbar {
  width: 5px;
}
.sidebar-content::-webkit-scrollbar-thumb,
.notes-panel::-webkit-scrollbar-thumb {
  background: #d7dce6;
  border-radius: 10px;
}
@media (max-width: 1400px) {
  .document-grid {
    grid-template-columns: repeat(auto-fill, minmax(175px, 1fr));
  }
}
@media (max-width: 1100px) {
  .document-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .document-viewer-layout {
    grid-template-columns: 1fr;
  }
  .viewer-sidebar {
    position: relative;
    top: auto;
  }
}
@media (max-width: 768px) {
  .document-library {
    padding: 15px;
  }
  .header-content {
    align-items: flex-start;
    flex-direction: column;
  }
  .library-stats {
    grid-template-columns: 1fr;
  }
  .document-grid {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 8px;
  }
  .viewer-content {
    min-height: 400px;
    padding: 8px;
  }
  .document-frame {
    height: 500px;
  }
  .viewer-details {
    flex-direction: column;
    gap: 8px;
  }
}
@media (max-width: 480px) {
  .document-library {
    padding: 10px;
  }
  .header-title h2 {
    font-size: 20px;
  }
  .title-icon {
    width: 42px;
    height: 42px;
  }
  .document-preview {
    height: 200px;
  }
  .viewer-header {
    padding: 0 12px;
  }
  .back-button span {
    display: none;
  }
  .sidebar-tabs button {
    font-size: 11px;
  }
}
.library-editor {
  width: 100%;
  min-height: 100%;
  padding: 24px;
  background: #f5f7fb;
  color: #172033;
  box-sizing: border-box;
}
.editor-card {
  width: 100%;
  max-width: 1500px;
  margin: 0 auto;
  background: #fff;
  border: 1px solid #e7eaf0;
  border-radius: 18px;
  box-shadow: 0 10px 35px rgba(25, 39, 70, 0.07);
  overflow: hidden;
}
.editor-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 20px;
  padding: 26px 30px 22px;
  border-bottom: 1px solid #edf0f5;
}
.editor-header .editor-eyebrow {
  display: block;
  margin-bottom: 5px;
  color: #667085;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}
.editor-header h2 {
  margin: 0;
  color: #172033;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.3;
}
.editor-header p {
  margin: 6px 0 0;
  color: #7b8495;
  font-size: 13px;
}
.close-btn {
  width: 36px;
  height: 36px;
  flex: 0 0 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e4e7ec;
  border-radius: 10px;
  background: #fff;
  color: #667085;
  cursor: pointer;
  transition: 0.2s ease;
}
.close-btn:hover {
  background: #f5f7fa;
  color: #172033;
  border-color: #d8dce4;
}
.editor-tabs {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 24px;
  background: #fafbfc;
  border-bottom: 1px solid #edf0f5;
  overflow-x: auto;
}
.editor-tab {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 9px;
  min-width: 110px;
  padding: 12px 17px;
  border: 0;
  border-radius: 10px;
  background: transparent;
  color: #737d8e;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease;
}
.editor-tab i {
  font-size: 14px;
}
.editor-tab:hover {
  background: #f0f3f8;
  color: #344054;
}
.editor-tab.is-active {
  background: #eef4ff;
  color: #3867d6;
}
.editor-tab.is-active::after {
  content: "";
  position: absolute;
  left: 18px;
  right: 18px;
  bottom: -11px;
  height: 2px;
  border-radius: 2px;
  background: #3867d6;
}
.editor-body {
  padding: 30px;
  min-height: 480px;
}
.content-tab {
  width: 100%;
}
.section-heading {
  display: flex;
  align-items: center;
  gap: 13px;
  margin-bottom: 24px;
}
.section-heading .section-icon {
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 11px;
  background: #eef4ff;
  color: #3867d6;
}
.section-heading .section-icon i {
  font-size: 17px;
}
.section-heading h3 {
  margin: 0;
  color: #1d2939;
  font-size: 16px;
  font-weight: 700;
}
.section-heading p {
  margin: 4px 0 0;
  color: #98a2b3;
  font-size: 12px;
}
.content-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 30px;
}
.editor-section {
  min-width: 0;
}
.form-field {
  margin-bottom: 20px;
}
.form-label {
  display: block;
  margin-bottom: 8px;
  color: #344054;
  font-size: 13px;
  font-weight: 600;
}
.required {
  color: #e5484d;
}
.form-input,
.input-wrapper {
  width: 100%;
  min-height: 42px;
  box-sizing: border-box;
  border: 1px solid #dfe3ea;
  border-radius: 9px;
  background: #fff;
  color: #1d2939;
  font-size: 13px;
  transition: all 0.2s ease;
}
.form-input {
  padding: 10px 13px;
  outline: none;
}
.form-input::placeholder {
  color: #a5adba;
}
.form-input:hover {
  border-color: #c7cdd8;
}
.form-input:focus {
  border-color: #6b8de3;
  box-shadow: 0 0 0 3px rgba(56, 103, 214, 0.1);
}
.form-input:read-only {
  background: #f8f9fb;
  color: #667085;
}
.input-wrapper {
  display: flex;
  align-items: center;
  gap: 9px;
  padding: 0 13px;
}
.input-wrapper i {
  color: #98a2b3;
}
.input-wrapper .form-input {
  min-height: 40px;
  padding-left: 0;
  border: 0;
  box-shadow: none;
}
.input-wrapper .form-input:focus {
  box-shadow: none;
}
.upload-box {
  min-height: 170px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1.5px dashed #cbd5e1;
  border-radius: 13px;
  background: #fafcff;
  transition: all 0.2s ease;
}
.upload-box:hover {
  border-color: #7090df;
  background: #f7f9ff;
}
.upload-content {
  width: 100%;
  padding: 25px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  cursor: pointer;
}
.upload-content strong {
  display: block;
  margin-top: 10px;
  color: #344054;
  font-size: 14px;
}
.upload-content span {
  display: block;
  margin-top: 5px;
  color: #7b8495;
  font-size: 12px;
}
.upload-content small {
  margin-top: 10px;
  color: #98a2b3;
  font-size: 11px;
}
.upload-icon {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 13px;
  background: #eef4ff;
  color: #3867d6;
}
.upload-icon i {
  font-size: 21px;
}
.uploaded-file {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 13px;
  margin-top: 10px;
  border: 1px solid #e5e8ee;
  border-radius: 11px;
  background: #fff;
}
.file-icon {
  width: 40px;
  height: 40px;
  flex: 0 0 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: #f4f6f9;
}
.file-icon img {
  max-width: 30px;
  max-height: 30px;
}
.file-info {
  min-width: 0;
  flex: 1;
}
.file-info strong {
  display: block;
  overflow: hidden;
  color: #344054;
  font-size: 13px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.file-info span {
  display: block;
  margin-top: 3px;
  color: #98a2b3;
  font-size: 11px;
}
.file-info progress {
  width: 100%;
  height: 4px;
  margin-top: 8px;
}
.file-remove,
.answer-remove,
.icon-danger {
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #98a2b3;
  cursor: pointer;
  transition: 0.2s ease;
}
.file-remove:hover,
.answer-remove:hover,
.icon-danger:hover {
  background: #fff1f2;
  color: #e5484d;
}
.setting-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px;
  border: 1px solid #e6e9ef;
  border-radius: 11px;
  background: #fafbfc;
}
.setting-icon {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 36px;
  border-radius: 9px;
  background: #eef4ff;
  color: #3867d6;
}
.setting-icon i {
  font-size: 14px;
}
.setting-content {
  flex: 1;
}
.setting-content strong {
  display: block;
  color: #344054;
  font-size: 13px;
  font-weight: 600;
}
.setting-content span {
  display: block;
  margin-top: 3px;
  color: #98a2b3;
  font-size: 11px;
}
.modern-switch {
  position: relative;
  width: 40px;
  height: 22px;
  flex: 0 0 40px;
}
.modern-switch input {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}
.modern-switch span {
  position: absolute;
  inset: 0;
  border-radius: 20px;
  background: #d5dae3;
  cursor: pointer;
  transition: 0.2s ease;
}
.modern-switch span::after {
  content: "";
  position: absolute;
  top: 3px;
  left: 3px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  transition: 0.2s ease;
}
.modern-switch input:checked + span {
  background: #3867d6;
}
.modern-switch input:checked + span::after {
  transform: translateX(18px);
}
.editor-wrapper,
.notes-editor {
  overflow: hidden;
  border: 1px solid #dfe3ea;
  border-radius: 11px;
  background: #fff;
}
:host ::ng-deep .p-editor-container {
  border: 0;
  border-radius: 11px;
  overflow: hidden;
}
:host ::ng-deep .p-editor-toolbar {
  border: 0;
  border-bottom: 1px solid #edf0f5;
  background: #fafbfc;
}
:host ::ng-deep .p-editor-content {
  border: 0;
}
:host ::ng-deep .ql-editor {
  font-size: 13px;
  color: #344054;
}
.assessment-settings {
  display: grid;
  grid-template-columns: 0.8fr 1.5fr 0.8fr;
  gap: 18px;
  padding: 18px;
  margin-bottom: 25px;
  border: 1px solid #e7eaf0;
  border-radius: 13px;
  background: #fafbfc;
}
.assessment-settings .form-field {
  margin-bottom: 0;
}
.question-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}
.question-card {
  border: 1px solid #e4e7ec;
  border-radius: 14px;
  background: #fff;
  overflow: hidden;
  transition: box-shadow 0.2s ease;
}
.question-card:hover {
  box-shadow: 0 5px 20px rgba(20, 35, 60, 0.05);
}
.question-header {
  min-height: 58px;
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 10px 16px;
  background: #fafbfc;
  border-bottom: 1px solid #edf0f5;
}
.question-header strong {
  color: #344054;
  font-size: 13px;
}
.question-header span {
  display: block;
  margin-top: 2px;
  color: #98a2b3;
  font-size: 11px;
}
.question-header .icon-danger {
  margin-left: auto;
}
.question-number {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: #eef4ff;
  color: #3867d6;
  font-size: 12px;
  font-weight: 700;
}
.question-body {
  padding: 20px;
}
.question-meta {
  display: grid;
  grid-template-columns: 1fr 180px;
  gap: 20px;
}
.radio-group {
  display: flex;
  flex-wrap: wrap;
  gap: 9px;
}
.radio-option {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 8px 11px;
  border: 1px solid #e1e5eb;
  border-radius: 8px;
  color: #667085;
  font-size: 12px;
  cursor: pointer;
}
.radio-option input {
  display: none;
}
.radio-option span {
  width: 14px;
  height: 14px;
  position: relative;
  border: 1px solid #c5cad4;
  border-radius: 50%;
}
.radio-option input:checked + span {
  border-color: #3867d6;
}
.radio-option input:checked + span::after {
  content: "";
  position: absolute;
  top: 3px;
  left: 3px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #3867d6;
}
.radio-option:has(input:checked) {
  border-color: #b7c8f5;
  background: #f5f8ff;
  color: #3867d6;
}
.answers-wrapper {
  margin-top: 20px;
  padding: 15px;
  border: 1px solid #edf0f5;
  border-radius: 11px;
  background: #fafbfc;
}
.answers-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
.answers-header .form-label {
  margin-bottom: 0;
}
.answers-header span {
  color: #98a2b3;
  font-size: 11px;
}
.answer-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 9px;
}
.answer-row .form-input {
  flex: 1;
}
.correct-answer {
  width: 35px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.correct-answer input {
  display: none;
}
.correct-answer span {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #d9dee7;
  border-radius: 8px;
  color: transparent;
  transition: 0.2s ease;
}
.correct-answer input:checked + span {
  border-color: #32a36b;
  background: #eaf8f1;
  color: #32a36b;
}
.add-button {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin-top: 5px;
  padding: 8px 11px;
  border: 1px dashed #aebbd6;
  border-radius: 8px;
  background: #fff;
  color: #3867d6;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}
.add-button:hover {
  background: #f5f8ff;
  border-color: #3867d6;
}
.add-question-button {
  width: 100%;
  min-height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 4px;
  border: 1px dashed #b6c1d4;
  border-radius: 10px;
  background: #fafbfc;
  color: #3867d6;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s ease;
}
.add-question-button:hover {
  border-color: #3867d6;
  background: #f5f8ff;
}
.error-message {
  display: block;
  margin-top: 5px;
  color: #e5484d;
  font-size: 11px;
}
.editor-footer {
  min-height: 72px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 14px 30px;
  border-top: 1px solid #edf0f5;
  background: #fff;
}
.btn-secondary,
.btn-primary {
  min-height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 17px;
  border-radius: 9px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}
.btn-secondary {
  border: 1px solid #dfe3ea;
  background: #fff;
  color: #475467;
}
.btn-secondary:hover:not(:disabled) {
  background: #f8f9fb;
}
.btn-primary {
  border: 1px solid #3867d6;
  background: #3867d6;
  color: #fff;
  box-shadow: 0 3px 8px rgba(56, 103, 214, 0.2);
}
.btn-primary:hover:not(:disabled) {
  background: #2f5bc5;
  border-color: #2f5bc5;
}
.btn-primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  box-shadow: none;
}
.btn-primary.loading {
  cursor: default;
}
@media (max-width: 1100px) {
  .content-grid {
    grid-template-columns: 1fr;
  }
  .assessment-settings {
    grid-template-columns: 1fr 1fr;
  }
}
@media (max-width: 768px) {
  .library-editor {
    padding: 10px;
  }
  .editor-card {
    border-radius: 13px;
  }
  .editor-header {
    padding: 20px;
  }
  .editor-header h2 {
    font-size: 18px;
  }
  .editor-tabs {
    padding: 8px 12px;
  }
  .editor-tab {
    min-width: auto;
    padding: 10px 12px;
  }
  .editor-tab span {
    display: none;
  }
  .editor-tab.is-active span {
    display: inline;
  }
  .editor-body {
    padding: 20px 15px;
  }
  .assessment-settings {
    grid-template-columns: 1fr;
  }
  .question-meta {
    grid-template-columns: 1fr;
    gap: 0;
  }
  .question-body {
    padding: 15px;
  }
  .editor-footer {
    padding: 12px 15px;
  }
  .editor-footer .btn-secondary,
  .editor-footer .btn-primary {
    flex: 1;
  }
}
@media (max-width: 480px) {
  .editor-header {
    align-items: center;
  }
  .editor-header p {
    display: none;
  }
  .section-heading .section-icon {
    width: 36px;
    height: 36px;
  }
  .section-heading h3 {
    font-size: 14px;
  }
  .upload-box {
    min-height: 145px;
  }
  .setting-card {
    align-items: flex-start;
  }
  .answer-row {
    flex-wrap: wrap;
  }
  .answer-row .form-input {
    width: calc(100% - 40px);
  }
  .correct-answer {
    width: 32px;
  }
  .editor-footer {
    flex-direction: column-reverse;
  }
  .editor-footer button {
    width: 100%;
  }
}
.empty-state-wrapper {
  width: 100%;
  min-height: 360px;
  padding: 40px 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}
.empty-state-card {
  width: 100%;
  max-width: 460px;
  padding: 42px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: #ffffff;
  border: 1px solid #e8edf3;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.04), 0 1px 3px rgba(15, 23, 42, 0.03);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.empty-state-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.07), 0 2px 6px rgba(15, 23, 42, 0.04);
}
.empty-state-icon {
  width: 72px;
  height: 72px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #f1f5ff;
  color: #253B80;
  font-size: 28px;
}
.empty-state-icon i {
  line-height: 1;
}
.empty-state-content h4 {
  margin: 0 0 8px;
  color: #172033;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.4;
}
.empty-state-content p {
  max-width: 360px;
  margin: 0 auto;
  color: #7b8494;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.6;
}
.modern-assessment-ui {
  --primary: #253B80;
  --primary-dark: #4338ca;
  --primary-soft: #eef2ff;
  --success: #16a34a;
  --success-soft: #ecfdf3;
  --danger: #dc2626;
  --danger-soft: #fef2f2;
  --warning: #d97706;
  --warning-soft: #fff7ed;
  --text: #172033;
  --text-secondary: #64748b;
  --text-light: #94a3b8;
  --border: #e2e8f0;
  --border-light: #eef2f7;
  --surface: #ffffff;
  --surface-soft: #f8fafc;
  --shadow: 0 20px 50px rgba(15, 23, 42, 0.12);
}
.modern-assessment-ui .modal-background {
  background: rgba(15, 23, 42, 0.65);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
}
.modern-assessment-ui .modal-card {
  width: min(1050px, 100vw - 40px);
  max-height: calc(100vh - 50px);
  margin: auto;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: var(--shadow);
  background: var(--surface);
}
@media (max-width: 768px) {
  .modern-assessment-ui .modal-card {
    width: calc(100vw - 20px);
    max-height: calc(100vh - 20px);
    border-radius: 14px;
  }
}
.modern-assessment-ui .card {
  border: 0;
  border-radius: 18px;
  overflow: hidden;
  background: var(--surface);
  box-shadow: none;
}
.modern-assessment-ui .card-header {
  position: relative;
  min-height: 68px;
  padding: 0 22px;
  display: flex;
  align-items: center;
  gap: 12px;
  background:
    linear-gradient(
      135deg,
      #253B80 0%,
      #6366f1 100%);
  border: 0;
  box-shadow: none;
}
.modern-assessment-ui .card-header .card-header-title {
  margin: 0;
  padding: 0;
  color: #fff;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: -0.2px;
}
.modern-assessment-ui .card-header .delete {
  margin-left: auto;
  flex-shrink: 0;
  background-color: rgba(255, 255, 255, 0.14);
}
.modern-assessment-ui .card-header .delete:hover {
  background-color: rgba(255, 255, 255, 0.25);
}
.modern-assessment-ui .card-header .delete::before,
.modern-assessment-ui .card-header .delete::after {
  background-color: #fff;
}
.modern-assessment-ui .card-header .header-question-count {
  margin-left: auto;
  color: rgba(255, 255, 255, 0.85);
  font-size: 13px;
  font-weight: 500;
}
.modern-assessment-ui .card-content {
  padding: 26px;
}
@media (max-width: 768px) {
  .modern-assessment-ui .card-content {
    padding: 18px;
  }
}
.modern-assessment-ui .scroll-bar {
  overflow-y: auto;
  max-height: calc(100vh - 240px);
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}
.modern-assessment-ui .scroll-bar::-webkit-scrollbar {
  width: 6px;
}
.modern-assessment-ui .scroll-bar::-webkit-scrollbar-track {
  background: transparent;
}
.modern-assessment-ui .scroll-bar::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 20px;
}
.modern-assessment-ui .question {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.modern-assessment-ui .question > div {
  padding: 20px;
  border: 1px solid var(--border);
  border-radius: 14px;
  background: var(--surface);
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    transform 0.2s ease;
}
.modern-assessment-ui .question > div:hover {
  border-color: #c7d2fe;
  box-shadow: 0 8px 24px rgba(79, 70, 229, 0.06);
}
.modern-assessment-ui .question h3,
.modern-assessment-ui .survey-question h3,
.modern-assessment-ui .poll-question h3 {
  margin: 0 0 16px;
  color: var(--text);
  font-size: 15px !important;
  line-height: 1.6;
  font-weight: 650;
}
.modern-assessment-ui .question h3:first-letter {
  color: var(--primary);
}
.modern-assessment-ui .options.surveyquiz {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.modern-assessment-ui .option {
  width: 100%;
}
.modern-assessment-ui .field {
  margin: 0;
}
.modern-assessment-ui .option .field {
  position: relative;
}
.modern-assessment-ui .option input[type=radio] {
  position: absolute;
  opacity: 0;
  pointer-events: none;
}
.modern-assessment-ui .option label {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 48px;
  padding: 12px 16px 12px 46px;
  border: 1px solid var(--border);
  border-radius: 10px;
  background: var(--surface-soft);
  color: #334155;
  font-size: 14px !important;
  line-height: 1.5;
  cursor: pointer;
  transition:
    background 0.2s ease,
    border-color 0.2s ease,
    color 0.2s ease,
    box-shadow 0.2s ease;
}
.modern-assessment-ui .option label::before {
  content: "";
  position: absolute;
  left: 16px;
  top: 50%;
  width: 17px;
  height: 17px;
  transform: translateY(-50%);
  border: 2px solid #cbd5e1;
  border-radius: 50%;
  background: #fff;
  transition: 0.2s ease;
}
.modern-assessment-ui .option label::after {
  content: "";
  position: absolute;
  left: 21px;
  top: 50%;
  width: 7px;
  height: 7px;
  transform: translateY(-50%) scale(0);
  border-radius: 50%;
  background: #fff;
  transition: 0.2s ease;
}
.modern-assessment-ui .option label:hover {
  border-color: #a5b4fc;
  background: var(--primary-soft);
  color: var(--primary);
}
.modern-assessment-ui .option input[type=radio]:checked + label {
  border-color: var(--primary);
  background: var(--primary-soft);
  color: var(--primary);
  font-weight: 600;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.08);
}
.modern-assessment-ui .option input[type=radio]:checked + label::before {
  border-color: var(--primary);
  background: var(--primary);
}
.modern-assessment-ui .option input[type=radio]:checked + label::after {
  transform: translateY(-50%) scale(1);
}
.modern-assessment-ui textarea.textarea {
  min-height: 130px;
  padding: 14px 16px;
  border: 1px solid var(--border);
  border-radius: 12px;
  background: var(--surface-soft);
  color: var(--text);
  font-size: 14px;
  line-height: 1.6;
  resize: vertical;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.modern-assessment-ui textarea.textarea:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.08);
  outline: none;
}
.modern-assessment-ui textarea.textarea::placeholder {
  color: #94a3b8;
}
.modern-assessment-ui .notification.is-danger {
  position: relative;
  margin-bottom: 20px;
  padding: 14px 44px 14px 16px;
  border: 1px solid #fecaca;
  border-radius: 10px;
  background: var(--danger-soft);
  color: var(--danger);
  font-size: 14px;
  font-weight: 600;
}
.modern-assessment-ui .notification.is-danger .delete {
  position: absolute;
  right: 10px;
  top: 10px;
}
.modern-assessment-ui .card-footer {
  min-height: 72px;
  padding: 14px 22px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  background: #fff;
  border-top: 1px solid var(--border);
}
.modern-assessment-ui .footer-elibrary {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
.modern-assessment-ui .button {
  min-height: 40px;
  padding: 0 17px;
  border-radius: 9px;
  border: 1px solid var(--border);
  font-size: 13px;
  font-weight: 600;
  transition:
    transform 0.15s ease,
    box-shadow 0.15s ease,
    background 0.15s ease;
}
.modern-assessment-ui .button:hover {
  transform: translateY(-1px);
}
.modern-assessment-ui .button.is-link {
  border-color: var(--primary);
  background: var(--primary);
  color: #fff;
}
.modern-assessment-ui .button.is-link:hover {
  background: var(--primary-dark);
  box-shadow: 0 5px 14px rgba(79, 70, 229, 0.25);
}
.modern-assessment-ui .button.is-link:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}
.modern-assessment-ui .button.is-primary {
  border-color: var(--primary);
  background: var(--primary-soft);
  color: var(--primary);
}
.modern-assessment-ui .button.is-primary:hover {
  background: #e0e7ff;
}
.modern-assessment-ui .button.is-outlined {
  background: #fff;
  border-color: var(--border);
  color: #475569;
}
.modern-assessment-ui .button.is-outlined:hover {
  border-color: #a5b4fc;
  color: var(--primary);
  background: var(--primary-soft);
}
.modern-assessment-ui table.table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border: 1px solid var(--border);
  border-radius: 12px;
  overflow: hidden;
  background: #fff;
}
.modern-assessment-ui table.table thead {
  background: var(--surface-soft);
}
.modern-assessment-ui table.table thead th {
  padding: 14px 16px;
  color: #475569;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  border-bottom: 1px solid var(--border);
}
.modern-assessment-ui table.table tbody tr {
  transition: background 0.15s ease;
}
.modern-assessment-ui table.table tbody tr:hover {
  background: #f8fafc;
}
.modern-assessment-ui table.table tbody tr:not(:last-child) td {
  border-bottom: 1px solid var(--border-light);
}
.modern-assessment-ui table.table tbody td {
  padding: 15px 16px;
  color: #475569;
  font-size: 13px;
  vertical-align: middle;
}
.modern-assessment-ui table.table .button {
  min-height: 34px;
  padding: 0 13px;
  font-size: 12px;
}
.modern-assessment-ui .card-content > .content > span {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 120px;
  padding: 25px;
  border: 1px dashed #cbd5e1;
  border-radius: 12px;
  background: var(--surface-soft);
  color: var(--text-secondary);
  font-size: 14px;
}
.modern-assessment-ui .has-text-success {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 8px 12px;
  border-radius: 8px;
  background: var(--success-soft);
  color: var(--success) !important;
  font-size: 13px;
  font-weight: 600;
}
.modern-assessment-ui .has-text-danger {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 8px 12px;
  border-radius: 8px;
  background: var(--danger-soft);
  color: var(--danger) !important;
  font-size: 13px;
  font-weight: 600;
}
.modern-assessment-ui .teacherRemarks {
  margin-top: 12px;
  padding: 16px;
  border: 1px solid var(--border);
  border-radius: 12px;
  background: var(--surface-soft);
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.modern-assessment-ui .teacherRemarks .input,
.modern-assessment-ui .teacherRemarks .textarea {
  width: 100%;
  border: 1px solid var(--border);
  border-radius: 9px;
  background: #fff;
}
.modern-assessment-ui .teacherRemarks .input:focus,
.modern-assessment-ui .teacherRemarks .textarea:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.08);
  outline: none;
}
.modern-assessment-ui .teacherRemarks .textarea {
  min-height: 85px;
}
.modern-assessment-ui .teacherRemarks .input {
  height: 42px;
  padding: 0 12px;
}
.modern-assessment-ui .student-result-header {
  display: flex;
  align-items: center;
  gap: 10px;
}
.modern-assessment-ui .student-result-header .back-button {
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: #fff;
  cursor: pointer;
  transition: background 0.2s ease;
}
.modern-assessment-ui .student-result-header .back-button:hover {
  background: rgba(255, 255, 255, 0.15);
}
.modern-assessment-ui .survey-question,
.modern-assessment-ui .poll-question {
  padding: 22px;
  border: 1px solid var(--border);
  border-radius: 14px;
  background: #fff;
}
.modern-assessment-ui .survey-question h3,
.modern-assessment-ui .poll-question h3 {
  margin-bottom: 20px;
}
.modern-assessment-ui .progress {
  width: 100%;
  height: 8px;
  margin: 10px 0 0;
  border-radius: 50px;
  overflow: hidden;
  background: #e2e8f0;
}
.modern-assessment-ui .progress::-webkit-progress-bar {
  background: #e2e8f0;
  border-radius: 50px;
}
.modern-assessment-ui .progress::-webkit-progress-value {
  background: var(--primary);
  border-radius: 50px;
}
.modern-assessment-ui .progress::-moz-progress-bar {
  background: var(--primary);
  border-radius: 50px;
}
.modern-assessment-ui .progress.is-success::-webkit-progress-value {
  background: var(--success);
}
.modern-assessment-ui .progress.is-success::-moz-progress-bar {
  background: var(--success);
}
.modern-assessment-ui .option.has-text-grey-light {
  padding: 14px;
  border: 1px solid var(--border);
  border-radius: 10px;
  color: #475569 !important;
  background: var(--surface-soft);
}
.modern-assessment-ui .option.has-text-grey-light .field {
  position: relative;
}
.modern-assessment-ui .option.has-text-grey-light .has-text-right {
  color: var(--text-secondary);
  font-size: 12px;
  font-weight: 600;
}
.modern-assessment-ui .pagination {
  width: 100%;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.modern-assessment-ui .pagination .pagination-previous,
.modern-assessment-ui .pagination .pagination-next {
  position: static;
  width: auto;
  min-width: 100px;
  margin: 0;
}
.modern-assessment-ui .pagination .answerSubmit {
  min-width: 120px;
}
.modern-assessment-ui .hidePreviousBtn {
  visibility: hidden;
}
.modern-assessment-ui .btnQAdisabled {
  opacity: 0.45;
  pointer-events: none;
}
.modern-assessment-ui .survey-modal .modal-card,
.modern-assessment-ui .poll-modal .modal-card {
  width: min(850px, 100vw - 40px);
}
.modern-assessment-ui .summarization-popup {
  display: none;
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(15, 23, 42, 0.65);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
  align-items: center;
  justify-content: center;
}
.modern-assessment-ui .summarization-popup.show {
  display: flex;
}
.modern-assessment-ui .summarization-popup .modal-dialog {
  width: min(750px, 100vw - 30px);
  margin: 0;
}
.modern-assessment-ui .summarization-popup .modal-content {
  border: 0;
  border-radius: 18px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 25px 60px rgba(15, 23, 42, 0.2);
}
.modern-assessment-ui .summarization-popup .modal-header {
  min-height: 65px;
  padding: 0 22px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 0;
  background:
    linear-gradient(
      135deg,
      #253B80,
      #6366f1);
}
.modern-assessment-ui .summarization-popup .modal-header .modal-title {
  margin: 0;
  color: #fff;
  font-size: 18px;
  font-weight: 700;
}
.modern-assessment-ui .summarization-popup .modal-header .pull-right {
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: #fff;
  cursor: pointer;
  transition: background 0.2s ease;
}
.modern-assessment-ui .summarization-popup .modal-header .pull-right:hover {
  background: rgba(255, 255, 255, 0.15);
}
.modern-assessment-ui .summarization-popup .modal-body {
  max-height: 70vh;
  overflow-y: auto;
  padding: 25px;
  color: #475569;
  font-size: 14px;
  line-height: 1.7;
}
.modern-assessment-ui .summarization-popup .modal-body p {
  margin-bottom: 12px;
}
.modern-assessment-ui .summarization-popup .modal-body strong {
  color: var(--text);
  font-weight: 700;
}
@media (max-width: 768px) {
  .modern-assessment-ui .card-header {
    min-height: 58px;
    padding: 0 16px;
  }
  .modern-assessment-ui .card-header .card-header-title {
    font-size: 16px;
  }
  .modern-assessment-ui .question > div,
  .modern-assessment-ui .survey-question,
  .modern-assessment-ui .poll-question {
    padding: 15px;
  }
  .modern-assessment-ui .card-footer {
    padding: 12px 16px;
  }
  .modern-assessment-ui .footer-elibrary {
    flex-wrap: wrap;
  }
  .modern-assessment-ui table.table {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
  }
  .modern-assessment-ui table.table th,
  .modern-assessment-ui table.table td {
    padding: 12px;
  }
  .modern-assessment-ui .pagination {
    gap: 8px;
  }
  .modern-assessment-ui .pagination .pagination-previous,
  .modern-assessment-ui .pagination .pagination-next {
    min-width: 90px;
  }
}
@media (max-width: 480px) {
  .modern-assessment-ui .modal-card {
    width: calc(100vw - 12px);
  }
  .modern-assessment-ui .card-content {
    padding: 14px;
  }
  .modern-assessment-ui .card-footer {
    min-height: auto;
  }
  .modern-assessment-ui .footer-elibrary {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  .modern-assessment-ui .footer-elibrary .button {
    width: 100%;
  }
  .modern-assessment-ui .option label {
    padding-left: 43px;
  }
  .modern-assessment-ui .pagination .pagination-previous,
  .modern-assessment-ui .pagination .pagination-next {
    min-width: 85px;
  }
}
.summarization-popup {
  z-index: 1060;
}
.summarization-popup.show {
  display: block;
  overflow-x: hidden;
  overflow-y: auto;
}
.summarization-popup .modal-dialog {
  max-width: 850px;
  width: calc(100% - 30px);
  margin: 28px auto;
}
.summarization-popup .modal-content {
  overflow: hidden;
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 18px;
  box-shadow: 0 25px 60px rgba(15, 23, 42, 0.18), 0 8px 25px rgba(15, 23, 42, 0.08);
  animation: summaryModalIn 0.25s ease;
}
.summarization-popup {
}
.summarization-popup .modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 22px;
  background: #ffffff;
  border-bottom: 1px solid #edf0f4;
}
.summarization-popup .summary-title-wrapper {
  display: flex;
  align-items: center;
  gap: 12px;
}
.summarization-popup .summary-icon {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #253B80;
  background: #eef2ff;
  border-radius: 12px;
}
.summarization-popup .summary-icon i {
  font-size: 17px;
}
.summarization-popup .modal-title {
  margin: 0;
  color: #172033;
  font-size: 17px;
  font-weight: 700;
}
.summarization-popup .summary-subtitle {
  display: block;
  margin-top: 3px;
  color: #94a3b8;
  font-size: 10px;
}
.summarization-popup .summary-close {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  color: #64748b;
  background: transparent;
  border: 0;
  border-radius: 9px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.summarization-popup .summary-close:hover {
  color: #1e293b;
  background: #f1f5f9;
  transform: rotate(90deg);
}
.summarization-popup {
}
.summarization-popup .modal-body {
  max-height: 68vh;
  padding: 22px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}
.summarization-popup .modal-body::-webkit-scrollbar {
  width: 6px;
}
.summarization-popup .modal-body::-webkit-scrollbar-track {
  background: transparent;
}
.summarization-popup .modal-body::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 10px;
}
.summarization-popup {
}
.summarization-popup .summary-section {
  margin-bottom: 25px;
}
.summarization-popup .summary-section:last-child {
  margin-bottom: 0;
}
.summarization-popup .section-title {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 12px;
}
.summarization-popup .section-title h6 {
  margin: 0;
  color: #1e293b;
  font-size: 13px;
  font-weight: 700;
}
.summarization-popup .section-title span {
  display: block;
  margin-top: 2px;
  color: #94a3b8;
  font-size: 10px;
}
.summarization-popup .section-icon {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
}
.summarization-popup .section-icon i {
  font-size: 13px;
}
.summarization-popup .metadata-icon {
  color: #2563eb;
  background: #eff6ff;
}
.summarization-popup .category-icon {
  color: #7c3aed;
  background: #f5f3ff;
}
.summarization-popup .summary-icon {
  color: #059669;
  background: #ecfdf5;
}
.summarization-popup {
}
.summarization-popup .metadata-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  overflow: hidden;
  background: #f8fafc;
  border: 1px solid #e7ebf0;
  border-radius: 12px;
}
.summarization-popup .metadata-item {
  min-width: 0;
  padding: 12px 14px;
  border-bottom: 1px solid #e7ebf0;
}
.summarization-popup .metadata-item:nth-child(odd) {
  border-right: 1px solid #e7ebf0;
}
.summarization-popup .metadata-item:nth-last-child(-n+2) {
  border-bottom: 0;
}
.summarization-popup .metadata-label {
  display: block;
  margin-bottom: 4px;
  color: #94a3b8;
  font-size: 10px;
}
.summarization-popup .metadata-value {
  display: block;
  overflow: hidden;
  color: #334155;
  font-size: 12px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.summarization-popup {
}
.summarization-popup .category-list {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
}
.summarization-popup .category-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 10px;
  color: #5b21b6;
  background: #f5f3ff;
  border: 1px solid #e9ddff;
  border-radius: 8px;
  font-size: 10px;
  font-weight: 600;
}
.summarization-popup .category-chip i {
  font-size: 8px;
}
.summarization-popup {
}
.summarization-popup .summary-text-wrapper {
  display: flex;
  overflow: hidden;
}
.summarization-popup .summary-accent {
  width: 3px;
  flex-shrink: 0;
}
.summarization-popup .summary-text {
  width: 100%;
  padding: 16px 18px;
  color: #475569;
  font-size: 12px;
  line-height: 1.75;
  text-align: justify;
}
.summarization-popup .summary-text ::ng-deep p {
  margin: 0 0 8px;
}
.summarization-popup .summary-text ::ng-deep p:last-child {
  margin-bottom: 0;
}
.summarization-popup .summary-text ::ng-deep strong {
  color: #1e293b;
  font-weight: 650;
}
.summarization-popup {
}
.summarization-popup .modal-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 13px 22px;
  background: #ffffff;
  border-top: 1px solid #edf0f4;
}
.summarization-popup .ai-generated {
  display: flex;
  align-items: center;
  gap: 7px;
  color: #94a3b8;
  font-size: 10px;
}
.summarization-popup .ai-generated i {
  color: #6366f1;
}
.summarization-popup .summary-btn {
  min-width: 75px;
  color: #ffffff;
  background: #253B80;
  border: 1px solid #253B80;
  border-radius: 8px;
  font-size: 11px;
  font-weight: 600;
}
.summarization-popup .summary-btn:hover {
  color: #ffffff;
  background: #4338ca;
  border-color: #4338ca;
}
.modal-backdrop {
  z-index: 1055;
  background: rgba(15, 23, 42, 0.55);
}
.modal-backdrop.show {
  opacity: 1;
  -webkit-backdrop-filter: blur(3px);
  backdrop-filter: blur(3px);
}
@keyframes summaryModalIn {
  from {
    opacity: 0;
    transform: translateY(15px) scale(0.98);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@media (max-width: 767px) {
  .summarization-popup .modal-dialog {
    width: calc(100% - 16px);
    margin: 30px auto;
  }
  .summarization-popup .modal-header {
    padding: 15px 16px;
  }
  .summarization-popup .modal-body {
    max-height: 72vh;
    padding: 17px 16px;
  }
  .summarization-popup .modal-footer {
    padding: 11px 16px;
  }
  .summarization-popup .summary-icon {
    width: 38px;
    height: 38px;
  }
  .summarization-popup .modal-title {
    font-size: 15px;
  }
  .summarization-popup .metadata-grid {
    grid-template-columns: 1fr;
  }
  .summarization-popup .metadata-item:nth-child(odd) {
    border-right: 0;
  }
  .summarization-popup .metadata-item:nth-last-child(-n+2) {
    border-bottom: 1px solid #e7ebf0;
  }
  .summarization-popup .metadata-item:last-child {
    border-bottom: 0;
  }
}
.modern-editor-modal {
  --editor-primary: #253B80;
  --editor-primary-dark: #4338ca;
  --editor-success: #16a34a;
  --editor-danger: #dc2626;
  --editor-text: #172033;
  --editor-muted: #667085;
  --editor-border: #e5e7eb;
  --editor-bg: #f7f8fc;
  --editor-white: #ffffff;
  --editor-radius: 14px;
  background: rgba(15, 23, 42, 0.58);
  -webkit-backdrop-filter: blur(5px);
  backdrop-filter: blur(5px);
}
.modern-editor-modal .modal-dialog {
  max-width: 1280px;
  width: calc(100% - 32px);
  margin: 20px auto;
}
.modern-editor-modal .editor-modal {
  height: calc(100vh - 40px);
  max-height: 900px;
  width: 100%;
  border: 0;
  border-radius: 18px;
  overflow: hidden;
  background: var(--editor-bg);
  box-shadow: 0 30px 80px rgba(15, 23, 42, 0.25), 0 10px 30px rgba(15, 23, 42, 0.12);
  display: flex;
  flex-direction: column;
}
.modern-editor-modal .editor-header {
  min-height: 76px;
  padding: 16px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: var(--editor-white);
  border-bottom: 1px solid var(--editor-border);
  flex-shrink: 0;
}
.modern-editor-modal .editor-header-info {
  display: flex;
  align-items: center;
  gap: 13px;
  min-width: 0;
}
.modern-editor-modal .editor-file-icon {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  color: var(--editor-primary);
  background: #eef2ff;
  font-size: 20px;
  flex-shrink: 0;
}
.modern-editor-modal .editor-title {
  margin: 0;
  color: var(--editor-text);
  font-size: 17px;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.modern-editor-modal .editor-subtitle {
  margin: 3px 0 0;
  color: var(--editor-muted);
  font-size: 12px;
}
.modern-editor-modal .editor-close {
  width: 38px;
  height: 38px;
  border: 0;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #667085;
  background: transparent;
  cursor: pointer;
  transition: 0.2s ease;
}
.modern-editor-modal .editor-close:hover {
  color: var(--editor-danger);
  background: #fef2f2;
}
.modern-editor-modal .editor-stepper {
  padding: 18px 28px 17px;
  background: var(--editor-white);
  border-bottom: 1px solid var(--editor-border);
  flex-shrink: 0;
}
.modern-editor-modal .stepper-track {
  display: flex;
  align-items: center;
  width: 100%;
}
.modern-editor-modal .step-item {
  padding: 0;
  border: 0;
  background: transparent;
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  text-align: left;
  flex-shrink: 0;
}
.modern-editor-modal .step-item:focus {
  outline: none;
}
.modern-editor-modal .step-icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f2f4f7;
  border: 1px solid #dfe3e8;
  color: #667085;
  position: relative;
  transition: all 0.2s ease;
}
.modern-editor-modal .step-number {
  font-size: 13px;
  font-weight: 700;
}
.modern-editor-modal .step-check {
  display: none;
  font-size: 14px;
}
.modern-editor-modal .step-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.modern-editor-modal .step-title {
  font-size: 12px;
  font-weight: 700;
  color: #475467;
  white-space: nowrap;
}
.modern-editor-modal .step-description {
  font-size: 10px;
  color: #98a2b3;
  white-space: nowrap;
}
.modern-editor-modal .step-line {
  flex: 1;
  height: 1px;
  margin: 0 14px;
  background: #e4e7ec;
  min-width: 20px;
}
.modern-editor-modal .step-item.active .step-icon {
  color: #fff;
  background: var(--editor-primary);
  border-color: var(--editor-primary);
  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.25);
}
.modern-editor-modal .step-item.active .step-title {
  color: var(--editor-primary);
}
.modern-editor-modal .step-item.completed .step-icon {
  color: #fff;
  background: var(--editor-success);
  border-color: var(--editor-success);
}
.modern-editor-modal .step-item.completed .step-number {
  display: none;
}
.modern-editor-modal .step-item.completed .step-check {
  display: block;
}
.modern-editor-modal .step-item.completed .step-title {
  color: #344054;
}
.modern-editor-modal .editor-body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 28px;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}
.modern-editor-modal .editor-body::-webkit-scrollbar {
  width: 7px;
}
.modern-editor-modal .editor-body::-webkit-scrollbar-track {
  background: transparent;
}
.modern-editor-modal .editor-body::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 20px;
}
.modern-editor-modal .editor-section {
  max-width: 1180px;
  margin: 0 auto;
}
.modern-editor-modal .section-heading {
  display: flex;
  align-items: center;
  gap: 13px;
  margin-bottom: 24px;
}
.modern-editor-modal .section-icon {
  width: 42px;
  height: 42px;
  border-radius: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #eef2ff;
  color: var(--editor-primary);
  font-size: 18px;
}
.modern-editor-modal .section-heading h3 {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: var(--editor-text);
}
.modern-editor-modal .section-heading p {
  margin: 3px 0 0;
  color: var(--editor-muted);
  font-size: 12px;
}
.modern-editor-modal .form-card {
  background: var(--editor-white);
  border: 1px solid var(--editor-border);
  border-radius: var(--editor-radius);
  padding: 20px;
  box-shadow: 0 2px 6px rgba(16, 24, 40, 0.03);
  margin-bottom: 18px;
}
.modern-editor-modal .form-card-title {
  display: flex;
  align-items: center;
  gap: 9px;
  padding-bottom: 15px;
  margin-bottom: 18px;
  border-bottom: 1px solid #f0f1f3;
  color: var(--editor-text);
  font-size: 13px;
  font-weight: 700;
}
.modern-editor-modal .form-card-title i {
  color: var(--editor-primary);
}
.modern-editor-modal .form-field {
  margin-bottom: 18px;
}
.modern-editor-modal .form-field > label,
.modern-editor-modal .form-field .form-label {
  display: block;
  margin-bottom: 7px;
  color: #344054;
  font-size: 12px;
  font-weight: 600;
}
.modern-editor-modal .required {
  color: var(--editor-danger);
}
.modern-editor-modal .modern-input,
.modern-editor-modal .input-icon input {
  width: 100%;
  min-height: 40px;
  border: 1px solid #d0d5dd;
  border-radius: 9px;
  padding: 9px 12px;
  background: #fff;
  color: #172033;
  font-size: 13px;
  outline: none;
  transition: all 0.2s ease;
}
.modern-editor-modal .modern-input:focus,
.modern-editor-modal .input-icon input:focus {
  border-color: var(--editor-primary);
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.08);
}
.modern-editor-modal .modern-input::placeholder,
.modern-editor-modal .input-icon input::placeholder {
  color: #98a2b3;
}
.modern-editor-modal .modern-input.compact {
  margin-top: 10px;
  max-width: 120px;
}
.modern-editor-modal .input-icon {
  position: relative;
}
.modern-editor-modal .input-icon i {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #98a2b3;
  font-size: 14px;
}
.modern-editor-modal .input-icon input {
  padding-left: 38px;
  background: #f9fafb;
}
.modern-editor-modal .upload-zone {
  min-height: 220px;
  border: 1.5px dashed #c7d2fe;
  border-radius: 13px;
  background: #f8f9ff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  position: relative;
  cursor: pointer;
  transition: all 0.2s ease;
}
.modern-editor-modal .upload-zone:hover {
  background: #f2f4ff;
  border-color: var(--editor-primary);
}
.modern-editor-modal .upload-zone h4 {
  margin: 10px 0 3px;
  color: #344054;
  font-size: 14px;
  font-weight: 700;
}
.modern-editor-modal .upload-zone p {
  margin: 0;
  color: #667085;
  font-size: 11px;
}
.modern-editor-modal .upload-input {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
}
.modern-editor-modal .upload-icon {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--editor-primary);
  background: #e0e7ff;
  font-size: 23px;
}
.modern-editor-modal .upload-limit {
  margin-top: 12px;
  color: #98a2b3;
  font-size: 10px;
}
.modern-editor-modal .uploaded-file,
.modern-editor-modal .existing-file {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border: 1px solid var(--editor-border);
  border-radius: 10px;
  background: #fafafa;
}
.modern-editor-modal .uploaded-file-icon {
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: #f2f4f7;
}
.modern-editor-modal .uploaded-file-info {
  min-width: 0;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.modern-editor-modal .uploaded-file-info strong {
  color: #344054;
  font-size: 12px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.modern-editor-modal .uploaded-file-info span {
  color: #98a2b3;
  font-size: 10px;
}
.modern-editor-modal .upload-progress {
  width: 100%;
  height: 4px;
  margin-top: 4px;
  accent-color: var(--editor-primary);
}
.modern-editor-modal .existing-file img {
  flex-shrink: 0;
}
.modern-editor-modal .existing-file div {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.modern-editor-modal .existing-file strong {
  font-size: 12px;
  color: #344054;
}
.modern-editor-modal .existing-file span {
  font-size: 10px;
  color: #98a2b3;
}
.modern-editor-modal .setting-card {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px;
  background: #fff;
  border: 1px solid var(--editor-border);
  border-radius: 11px;
  margin-bottom: 12px;
}
.modern-editor-modal .setting-icon {
  width: 38px;
  height: 38px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f2f4ff;
  color: var(--editor-primary);
  flex-shrink: 0;
}
.modern-editor-modal .setting-content {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}
.modern-editor-modal .setting-content strong {
  color: #344054;
  font-size: 12px;
  font-weight: 700;
}
.modern-editor-modal .setting-content span {
  margin-top: 2px;
  color: #98a2b3;
  font-size: 10px;
}
.modern-editor-modal .settings-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 20px;
}
.modern-editor-modal .settings-grid .setting-card {
  margin: 0;
  align-items: flex-start;
}
.modern-editor-modal .modern-switch {
  position: relative;
  width: 42px;
  height: 23px;
  flex-shrink: 0;
}
.modern-editor-modal .modern-switch input {
  display: none;
}
.modern-editor-modal .modern-switch span {
  position: absolute;
  inset: 0;
  background: #d0d5dd;
  border-radius: 30px;
  cursor: pointer;
  transition: 0.2s ease;
}
.modern-editor-modal .modern-switch span::before {
  content: "";
  position: absolute;
  width: 17px;
  height: 17px;
  left: 3px;
  top: 3px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.18);
  transition: 0.2s ease;
}
.modern-editor-modal .modern-switch input:checked + span {
  background: var(--editor-primary);
}
.modern-editor-modal .modern-switch input:checked + span::before {
  transform: translateX(19px);
}
.modern-editor-modal .creation-panel {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 18px 20px;
  margin-bottom: 18px;
  border: 1px solid #dbe3ff;
  border-radius: 13px;
  background:
    linear-gradient(
      135deg,
      #f8f9ff,
      #fff);
}
.modern-editor-modal .creation-panel h4 {
  margin: 0;
  color: var(--editor-text);
  font-size: 14px;
  font-weight: 700;
}
.modern-editor-modal .creation-panel p {
  margin: 4px 0 0;
  color: var(--editor-muted);
  font-size: 11px;
}
.modern-editor-modal .creation-actions {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}
.modern-editor-modal .btn-modern {
  min-height: 38px;
  padding: 8px 15px;
  border: 1px solid transparent;
  border-radius: 9px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
}
.modern-editor-modal .btn-modern:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.modern-editor-modal .btn-modern.primary {
  color: #fff;
  background: var(--editor-primary);
}
.modern-editor-modal .btn-modern.primary:hover:not(:disabled) {
  background: var(--editor-primary-dark);
  transform: translateY(-1px);
}
.modern-editor-modal .btn-modern.secondary {
  color: #344054;
  background: #fff;
  border-color: #d0d5dd;
}
.modern-editor-modal .btn-modern.secondary:hover:not(:disabled) {
  background: #f9fafb;
  border-color: #98a2b3;
}
.modern-editor-modal .btn-modern.success {
  color: #fff;
  background: var(--editor-success);
}
.modern-editor-modal .btn-modern.ghost {
  color: #667085;
  background: transparent;
}
.modern-editor-modal .btn-modern.ghost:hover {
  color: #344054;
  background: #f2f4f7;
}
.modern-editor-modal .btn-modern.small {
  min-height: 32px;
  padding: 6px 11px;
  font-size: 11px;
}
.modern-editor-modal .icon-button {
  width: 32px;
  height: 32px;
  border: 0;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #f2f4f7;
  color: #667085;
  cursor: pointer;
  transition: 0.2s ease;
}
.modern-editor-modal .icon-button.danger:hover {
  color: var(--editor-danger);
  background: #fef2f2;
}
.modern-editor-modal .question-card {
  margin-bottom: 16px;
  border: 1px solid var(--editor-border);
  border-radius: 13px;
  background: #fff;
  overflow: hidden;
  box-shadow: 0 2px 6px rgba(16, 24, 40, 0.025);
}
.modern-editor-modal .question-card-header {
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 13px 16px;
  background: #fafbfc;
  border-bottom: 1px solid var(--editor-border);
}
.modern-editor-modal .question-number {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9px;
  background: #eef2ff;
  color: var(--editor-primary);
  font-size: 12px;
  font-weight: 700;
}
.modern-editor-modal .question-header-info {
  flex: 1;
  display: flex;
  flex-direction: column;
}
.modern-editor-modal .question-header-info span {
  color: #344054;
  font-size: 12px;
  font-weight: 700;
}
.modern-editor-modal .question-header-info small {
  margin-top: 2px;
  color: #98a2b3;
  font-size: 10px;
}
.modern-editor-modal .question-card-body {
  padding: 18px;
}
.modern-editor-modal .question-type {
  display: flex;
  flex-direction: column;
  gap: 7px;
}
.modern-editor-modal .question-type label {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #667085;
  font-size: 11px;
  cursor: pointer;
}
.modern-editor-modal .answers-section {
  margin-top: 20px;
  padding-top: 18px;
  border-top: 1px solid #eaecf0;
}
.modern-editor-modal .answers-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
.modern-editor-modal .answers-header strong {
  display: block;
  color: #344054;
  font-size: 12px;
}
.modern-editor-modal .answers-header span {
  display: block;
  margin-top: 2px;
  color: #98a2b3;
  font-size: 10px;
}
.modern-editor-modal .answers-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.modern-editor-modal .answer-row {
  display: flex;
  align-items: center;
  gap: 9px;
}
.modern-editor-modal .answer-letter {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  background: #f2f4f7;
  color: #667085;
  font-size: 10px;
  font-weight: 700;
  flex-shrink: 0;
}
.modern-editor-modal .answer-row .modern-input {
  flex: 1;
}
.modern-editor-modal .correct-answer {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #667085;
  font-size: 10px;
  white-space: nowrap;
  cursor: pointer;
}
.modern-editor-modal .editor-footer {
  min-height: 68px;
  padding: 13px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  border-top: 1px solid var(--editor-border);
  flex-shrink: 0;
}
.modern-editor-modal .footer-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}
.modern-editor-modal .editor-wrapper .p-editor-container {
  border: 1px solid #d0d5dd;
  border-radius: 10px;
  overflow: hidden;
}
.modern-editor-modal .editor-wrapper .p-editor-container:focus-within {
  border-color: var(--editor-primary);
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.08);
}
.modern-editor-modal .editor-wrapper .p-editor-toolbar {
  border: 0;
  border-bottom: 1px solid #eaecf0;
  background: #f9fafb;
}
.modern-editor-modal .editor-wrapper .p-editor-content {
  border: 0;
}
@media (max-width: 991px) {
  .modern-editor-modal .modal-dialog {
    width: calc(100% - 20px);
    margin: 10px auto;
  }
  .modern-editor-modal .editor-modal {
    height: calc(100vh - 20px);
  }
  .modern-editor-modal .editor-body {
    padding: 20px;
  }
  .modern-editor-modal .settings-grid {
    grid-template-columns: 1fr;
  }
  .modern-editor-modal .step-description {
    display: none;
  }
  .modern-editor-modal .step-info {
    display: none;
  }
  .modern-editor-modal .step-line {
    margin: 0 8px;
  }
}
@media (max-width: 767px) {
  .modern-editor-modal .editor-header {
    padding: 13px 16px;
  }
  .modern-editor-modal .editor-title {
    font-size: 14px;
  }
  .modern-editor-modal .editor-subtitle {
    display: none;
  }
  .modern-editor-modal .editor-stepper {
    padding: 13px 15px;
    overflow-x: auto;
  }
  .modern-editor-modal .stepper-track {
    min-width: 500px;
  }
  .modern-editor-modal .step-icon {
    width: 32px;
    height: 32px;
  }
  .modern-editor-modal .editor-body {
    padding: 15px;
  }
  .modern-editor-modal .section-heading {
    margin-bottom: 18px;
  }
  .modern-editor-modal .section-heading h3 {
    font-size: 16px;
  }
  .modern-editor-modal .creation-panel {
    align-items: flex-start;
    flex-direction: column;
  }
  .modern-editor-modal .creation-actions {
    width: 100%;
  }
  .modern-editor-modal .creation-actions .btn-modern {
    flex: 1;
  }
  .modern-editor-modal .answer-row {
    flex-wrap: wrap;
  }
  .modern-editor-modal .answer-row .modern-input {
    min-width: calc(100% - 40px);
  }
  .modern-editor-modal .correct-answer {
    margin-left: 37px;
  }
  .modern-editor-modal .editor-footer {
    padding: 11px 15px;
  }
  .modern-editor-modal .footer-actions {
    gap: 5px;
  }
  .modern-editor-modal .footer-actions .btn-modern {
    padding: 7px 10px;
  }
}
@media (max-width: 480px) {
  .modern-editor-modal .editor-footer {
    flex-wrap: wrap;
    gap: 8px;
  }
  .modern-editor-modal .editor-footer > .btn-modern {
    flex: 1;
  }
  .modern-editor-modal .footer-actions {
    width: 100%;
  }
  .modern-editor-modal .footer-actions .btn-modern {
    flex: 1;
  }
  .modern-editor-modal .question-card-body {
    padding: 13px;
  }
  .modern-editor-modal .form-card {
    padding: 15px;
  }
}
/*# sourceMappingURL=e-library-tile.component.css.map */
